import React from 'react';
import { Divider, Box } from '@televet/kibble-ui/build/chakra';
import { NotificationMessage } from './NotificationMessage';
import { AutomationPrompts } from './AutomationPrompts';
import { useGetFieldVisibility } from 'pages/Automations/hooks/useGetFieldVisibility';

export const AutomationsCompose = (): JSX.Element => {
  const fieldIsVisible = useGetFieldVisibility();

  return (
    <Box className="Automations__ComposePageContainer" width={600} pt={10}>
      {fieldIsVisible.notificationBody && (
        <>
          <NotificationMessage />
          <Divider my={10} />
        </>
      )}
      <AutomationPrompts />
    </Box>
  );
};
